import React from 'react';
import InstantScanEdit from './InstantScanEdit';

const InstantScanList = () => <InstantScanEdit />;

export default InstantScanList;
